import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../../../infrastructure/infrastructure.module';
import { Observable } from 'rxjs';
import { api } from '@bayclubs/utils'
import { camps } from '../../models/models.generated';

@Injectable()
export class FilterApiService {

    constructor(private http: ApiHttpClient) { }

    public get( showLoader: boolean = true)
    : Observable<api.OperationResultValue<camps.OfficeFiltersContext>> {
        return this.http.get<api.OperationResultValue<camps.OfficeFiltersContext>>('filter',  showLoader);
    }

}
